import { Currency, PurchaseCost as PurchaseCostResponse } from '@galaxy/billing';

export class PurchaseCost {
  billingFrequency: string;
  totalCost: number;
  subtotalCost: number;
  setupFee: number;
  currency: string;
  initialCommitment: number;
  recurringCommitment: number;
  isStartingPrice: boolean;
  discountAmount: number;

  public static fromGetPurchaseCostResponse(response: PurchaseCostResponse): PurchaseCost {
    if (!response) {
      return null;
    }
    const purchaseCost = new PurchaseCost();
    purchaseCost.billingFrequency = response.billingFrequency.replace('_', ' ').toLowerCase();
    purchaseCost.totalCost = response.total || 0;
    purchaseCost.subtotalCost = response.subtotal || 0;
    purchaseCost.setupFee = response.setupFee || 0;
    purchaseCost.currency = Currency[response.currency] || 'USD';
    purchaseCost.isStartingPrice = response.isStartingPrice;
    purchaseCost.discountAmount = response.discountTotal || 0;
    if (response.commitment) {
      purchaseCost.initialCommitment = response.commitment.initial;
      purchaseCost.recurringCommitment = response.commitment.recurring;
    }
    return purchaseCost;
  }
}
